<template>
  <div class="page-title py-5 bg-custom-gradient position-relative rounded-top rounded-25">
    <div class="col-12 col-lg-7 mx-auto bg-light d-flex align-items-center justify-content-center meeting-success">
      <img src="@/assets/images/success-icon.svg" width="90" alt="" />
    </div>
    <h5 class="text-center text-white fw-bold mt-3">شكرا لك!</h5>
    <div class="text-white opacity-75 fs-6 text-center">تم حجز الموعد بنجاح, ستصلك رسالة إلى بريدك الإلكتروني بتفاصيل الإجتماع</div>
    <div class="col-12 col-lg-5 mx-auto">
    <div class="d-flex bg-white bg-opacity-25 rounded-12px align-items-center border border-2 p-3 m-3">
      <div class="d-flex flex-column align-items-center px-3">
        <span class="fw-bold text-white">الاثنين</span>
        <span class="fs-4 text-white">13</span>
      </div>
      <div class="d-flex flex-column section-seperator px-3">
        <img src="@/assets/images/zoom-light.svg" width="44" alt="" />
        <span class="text-white fs-4">12:00</span>
        <span class="text-white fs-12px">مدة الإجتماع : 30د</span>
      </div>
    </div>
    <div class="d-grid mx-3">
      <button class="btn btn-light rounded-pill py-3 d-flex align-items-center justify-content-center gap-2">
        <img src="@/assets/images/Google_Calendar.max-1100x1100.svg" alt="" />
        <div class="text-primary fw-bold">إضافة الموعد إلى التقويم</div>
      </button>
    </div>
    </div>

  </div>
  <div class="container mt-5">
    <div class="row">
      <div class="col-12 col-lg-7 mx-auto">
        <div class="mb-3">
          <label class="text-dark mb-2">البريد الإلكتروني</label>
          <div class="position-relative">
              <input type="email" :readonly="isReadOnly" class="form-control text-secondary py-3" value="name@name.com" />
              <div @click="isReadOnly = !isReadOnly" type="button" class=" position-absolute top-50 start-0 translate-middle ms-5">
                <button v-if="isReadOnly" class="btn text-secondary fw-bold text-decoration-underline">تعديل</button>
                <button v-if="!isReadOnly" class="btn text-success fw-bold text-decoration-underline">حفظ</button>
              </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-7 mx-auto">
        <div class="alert border-danger bg-danger bg-opacity-4 rounded-12px p-3" style="">
          <span class="text-dark fs-12px">ملاحظة:</span>
          <div class="text-secondary fs-12px">إذا تعذر عليك حضور الاجتماع او اردت الإلغاء فيمكنك ذلك عن طريق الرابط في نهاية الرسالة في بريدك الإلكتروني</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
export default {
  setup(){
    const isReadOnly = ref(true);

    return {isReadOnly}
  }
}
</script>

<style>
</style>